<template>
  <div class="recommended-item">
    <div class="recommended-item__thumbnail">
      <a :href="item.link" target="_blank" class="recommended-item__anchor">
        <img
          :src="`/theme/rbFront/img/w/magnit/contents/RecomendedProduct/${item.thumbnail}`"
          alt=""
        />
      </a>
    </div>
    <div class="recommended-item__subtext" v-text="item.description" />
    <div class="recommended-item__title" v-text="item.modelname" />
    <a :href="item.link" target="_blank" class="recommended-item__cta">
      Learn More
    </a>
  </div>
</template>
<script>
export default {
  name: 'recommendedItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.recommended-item {
  &__thumbnail {
    font-size: 0;
    img {
      width: 100%;
    }
  }
  &__subtext {
    font-size: 18px;
    font-weight: 400;
    margin-top: 20px;
  }
  &__title {
    font-size: 24px;
    font-weight: 600;
    margin-top: 8px;
  }
  &__cta {
    height: 33px;
    line-height: 32px;
    font-size: 18px;
    font-weight: 400;
    color: #fff;
    background-color: #fd312e;
    border-radius: 16px;
    display: inline-flex;
    align-items: center;
    padding: 0 24px;
    margin-top: 24px;
  }
  @media screen and (max-width: 1080px) {
    &__subtext {
      font-size: 11px;
      margin-top: 12.5px;
    }
    &__title {
      font-size: 14px;
      margin-top: 6.5px;
    }
    &__cta {
      font-size: 12px;
      height: 28px;
      line-height: 27px;
      margin-top: 15px;
      padding: 0 16px;
    }
  }
}
</style>
